import { observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.

export const EmailValidationRules: EntityValidationRules<NotificationPreferencesResponse> = {
  emailAddress: {
    isEmail: true,
  },
};

export const EmailConfirmationValidationRules: EntityValidationRules<NotificationPreferencesResponse> = {
  _emailConfirmation: {
    equalWith: { property: "emailAddress" as const },
    isEmail: true,
  },
};

export const EmailNotificationValidationRules: EntityValidationRules<NotificationPreferencesResponse> = {
  _emailAddressNotification: {
    equalWith: { property: "emailAddress" as const },
    isEmail: true,
  },
};
export default class NotificationPreferencesResponse {
  /**
   * Phone number.
   */
  @observable
  phoneNumber?: string;

  /**
   * E-mail address.
   */
  @observable
  emailAddress?: string;

  /**
   * If true - user is notified before the expiration of a charge by e-mail.
   */
  @observable
  emailNotificationEnabled?: boolean;

  /**
   * If true - user is notified before the expiration of a charge by SMS.
   */
  @observable
  smsNotificationEnabled?: boolean;

  @observable
  _emailAddressNotification?: string;

  @observable
  _isNotificationEmailSame = false;

  @observable
  _emailConfirmation?: string;

  @observable
  _notificationEnabled = false;
}

export const NotificationValidationRules: EntityValidationRules<NotificationPreferencesResponse> = {
  emailAddress: {
    isEmail: true,
  },
  _emailConfirmation: {
    equalWith: { property: "emailAddress" as const },
    isEmail: true,
  },
  _emailAddressNotification: {
    requiredIf: {
      condition: (entity: NotificationPreferencesResponse) => !entity.phoneNumber && entity._notificationEnabled,
      customMessage: "requiredContact",
    },
    isEmail: {
      required: false,
    },
  },
  phoneNumber: {
    requiredIf: {
      condition: (entity: NotificationPreferencesResponse) => !entity._emailAddressNotification && entity._notificationEnabled,
      customMessage: "requiredContact",
    },
    isPhoneNumber: {
      required: false,
    },
  },
};
